import { render, staticRenderFns } from "./AdminActions.vue?vue&type=template&id=52067566&scoped=true&lang=pug"
import script from "./AdminActions.vue?vue&type=script&lang=js"
export * from "./AdminActions.vue?vue&type=script&lang=js"
import style0 from "./AdminActions.vue?vue&type=style&index=0&id=52067566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52067566",
  null
  
)

export default component.exports